<template lang="pug">
.recommendations
  .start-again-wrapper(v-if="settings?.recommendationsPageOptions?.startAgainButton")
    StartAgainButton 
  .recommendations-list-wrapper
      RecommendationListCard.recommendations-list
      .reset-button-wrapper(v-if="showButton")
        Button.brp-button.p-button-outlined(
          v-if="steps.length !== 0"
          label="Reset home upgrade roadmap"
          @click="showPopup"
        )
        ResetRecommendationsButton
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import RecommendationListCard from "@/components/result/recommendations/RecommendationListCard.vue";
import ResetRecommendationsButton from "@/components/result/recommendations/ResetRecommendationsButton.vue";
import StartAgainButton from "@/components/result/StartAgainButton.vue";
import ProgressSpinner from "primevue/progressspinner";
import { useRecommendations } from "@/store/recommendations";
import { storeToRefs } from "pinia";
import {usePassport, useSettings} from "@/store";
import { ButtonPosition } from "@/types";
import Button from "primevue/button"
import {useConfirm} from "primevue/useconfirm";
import {t} from "@/helpers/locale";

export default defineComponent({
  components: {
    RecommendationListCard,
    ResetRecommendationsButton,
    ProgressSpinner,
    StartAgainButton,
    Button,
  },
  setup() {
    const { recommendationsPageLoading, isLoadingReport } = storeToRefs(
      useRecommendations()
    );
    const { settings } = storeToRefs(useSettings());
    const passport = usePassport();
    const { steps } = storeToRefs(passport);
    const { clear } = passport;
    const confirm = useConfirm()
    const showButton = computed(
      () =>
        settings.value &&
        (settings.value.recommendationsPageOptions?.resetButtonPosition ==
          undefined ||
          settings.value.recommendationsPageOptions?.resetButtonPosition ===
            ButtonPosition.Default)
    );

    const showPopup = () => {
      confirm.require({
        message: "This will reset your home upgrade roadmap and clear all selected steps. Continue?",
        header: "Reset home upgrade roadmap",
        icon: "pi pi-exclamation-triangle",
        accept: clear,
      });
    };
    return {
      isLoadingReport,
      recommendationsPageLoading,
      settings,
      ButtonPosition,
      showButton,
      showPopup,
      steps
    };
  },
});
</script>

<style lang="scss" scoped>
.recommendations {
  display: flex;
  flex-direction: column;
  width: 100%;
  .recommendations-list-wrapper {
    flex: 1;
    padding: 0;
  }

  .reset-button-wrapper {
    margin-top: 1.5rem;
    display: flex;
    justify-content: flex-end;
    gap: 1.25rem;
    :deep(.p-button:not(.brp-button)) {
      width: 20%;
    }
  }
}
@media screen and (max-width: 800px) {
  .reset-button-wrapper {
    :deep(.p-button) {
      width: 100% !important;
      height: 3rem;
      margin-bottom: 0.75rem;
    }
  }
}

</style>
